import { render, staticRenderFns } from "./koniptDetails.vue?vue&type=template&id=8f855bee&scoped=true"
import script from "./koniptDetails.vue?vue&type=script&lang=js"
export * from "./koniptDetails.vue?vue&type=script&lang=js"
import style0 from "./koniptDetails.vue?vue&type=style&index=0&id=8f855bee&prod&lang=less"
import style1 from "./koniptDetails.vue?vue&type=style&index=1&id=8f855bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f855bee",
  null
  
)

export default component.exports